module.exports = __webpack_public_path__ + "img/fangda.1d2db3c8.svg";